import { MavPlusTable } from './admin-mav-table';

export { MavPlusTable };
